const stripeIntentUrlFor = (accountId: string, intentId: string) => {
  const environment = window.origin.includes('localhost') ? '/test' : ''
  return `https://dashboard.stripe.com/${accountId}${environment}/payments/${intentId}`
}

export default stripeIntentUrlFor
